<a [routerLink]="route" [queryParams]="params">
  <ng-content></ng-content>
</a>
